// src/Components/careers/JobDetailsPage.tsx

import React from "react";
import { useParams, Link } from "react-router-dom";
import "./jobDetailsPage.css";
import { getJobById } from "./jobsData";

const JobDetailsPage: React.FC = () => {
  const { jobId } = useParams<{ jobId: string }>();
  const job = getJobById(jobId);

  if (!job) {
    return (
      <div className="jobdetails-root">
        <div className="jobdetails-inner jobdetails-notfound">
          <h2>Job not found</h2>
          <Link to="/careers" className="jobdetails-back-link">
            ← Back to Job Listing
          </Link>
        </div>
      </div>
    );
  }

  const applyMail = `mailto:careers@noridcworks.com
    ?subject=Application for ${job.title}
    &body=Hello Nordic Integration Works Team,%0D%0A%0D%0A
    I would like to apply for the position of ${job.title}.%0D%0A
    Location: ${job.location}%0D%0A%0D%0A
    Please find my resume attached.%0D%0A%0D%0A
    Regards,%0D%0A
    [Your Name]`;

  return (
    <div className="jobdetails-root">
      {/* ===== HEADER ===== */}
      <header className="career-header">
        
        <div className="career-header-inner">
          <h1 className="career-title">{job.title}</h1>
          <p className="career-subtitle">{job.location}</p>
        </div>
      </header>

      {/* ===== MAIN ===== */}
      <main className="jobdetails-main">
        <div className="jobdetails-inner">
          {/* LEFT CONTENT */}
          <section className="jobdetails-left">
            <Link to="/careers" className="jobdetails-back-link">
                ← Back to Job Listing
              </Link>
            <h2 className="jobdetails-heading">{job.title}</h2>
            <p className="jobdetails-location">{job.location}</p>

            {/* Overview */}
            <ul className="jobdetails-bullets">
              {job.overviewBullets.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>

            {/* Sections */}
            {job.sections.map((section) => (
              <div key={section.heading} className="jobdetails-section">
                <h3>{section.heading}</h3>
                <ul>
                  {section.items.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </section>

          {/* RIGHT CARD */}
           
          <aside className="jobdetails-right">
            <div className="jobdetails-card">
              <h3>Job Overview</h3>

              <div className="jobdetails-meta-row">
                <span className="meta-label">Position</span>
                <span className="meta-value">{job.title}</span>
              </div>

              <div className="jobdetails-meta-row">
                <span className="meta-label">Location</span>
                <span className="meta-value">{job.location}</span>
              </div>

              <div className="jobdetails-meta-row">
                <span className="meta-label">Vacancies</span>
                <span className="meta-value">{job.vacancies}</span>
              </div>

              <div className="jobdetails-meta-row">
                <span className="meta-label">Key Skills</span>
                <span className="meta-value">{job.keySkills}</span>
              </div>

              {/* APPLY NOW */}
              <a
                href={applyMail}
                className="jobdetails-apply-btn"
              >
                Apply Now
              </a>

             
            </div>
          </aside>
        </div>
      </main>

      <div style={{ height: "80px" }} />
    </div>
  );
};

export default JobDetailsPage;
